/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PassengerAgeRange
 */
export interface PassengerAgeRange {
    /**
     * 
     * @type {number}
     * @memberof PassengerAgeRange
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof PassengerAgeRange
     */
    to?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PassengerAgeRange
     */
    exclude?: boolean;
}

export function PassengerAgeRangeFromJSON(json: any): PassengerAgeRange {
    return PassengerAgeRangeFromJSONTyped(json, false);
}

export function PassengerAgeRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PassengerAgeRange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function PassengerAgeRangeToJSON(value?: PassengerAgeRange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'exclude': value.exclude,
    };
}


